import { LandingContent } from "./types";

export const reputationManagementLanding: LandingContent = {
  ctaText: "See a demo",
  quickFacts: ["SMS-first", "AI-assisted", "Cross-platform"],
  whyHeading: "Why teams use Reputation Management",
  why: "92% of homeowners check reviews before booking service. Reputation Management triggers a review request the instant a job completes — via SMS for highest response — and routes unhappy customers to a private feedback form before they post publicly. AI drafts responses your office approves in one tap.",
  advantages: [
    {
      title: "Trigger automation",
      description:
        "Review requests fire when a job is marked complete — via SMS for highest response.",
      includedNote: "SMS review requests at job completion",
    },
    {
      title: "AI response drafting",
      description:
        "Our model reads each review and drafts an on-brand response your office reviews, edits, and posts.",
      includedNote: "AI-drafted responses, one-tap approval",
    },
    {
      title: "Negative review shield",
      description:
        "1- and 2-star responses route to a private feedback form before going public, giving you a chance to resolve first.",
      includedNote: "Private feedback loop for unhappy customers",
    },
  ],
  featureChecklist: [
    "SMS review requests at job completion",
    "AI-drafted responses, one-tap approval",
    "Private feedback loop for unhappy customers",
    "Competitive tracking across your market",
  ],
  highlights: [],
  steps: [
    {
      title: "Connect your CRM",
      description:
        "Integrates with ServiceLine, ServiceTitan, HouseCall Pro, and most other field service platforms.",
    },
    {
      title: "Reviews go automatic",
      description:
        "SMS request fires the moment a job is marked complete. Most customers respond within 30 minutes.",
    },
    {
      title: "AI drafts your replies",
      description:
        "Each review surfaces with a draft response. Approve in one tap, edit, or write your own.",
    },
    {
      title: "Track your market",
      description:
        "Competitive dashboard shows where you rank against the other contractors in your service area.",
    },
  ],
  testimonials: [],
  faqs: [
    {
      question: "How fast will I see new reviews?",
      answer:
        "Most teams see their first new reviews within 48 hours of activation.",
    },
    {
      question: "Will it integrate with my software?",
      answer:
        "Yes — we support all major field service platforms via direct integration or Zapier.",
    },
    {
      question: "What happens if a customer leaves a bad review?",
      answer:
        "Negative responses are intercepted via the private feedback flow first, giving you a chance to resolve before anything goes public.",
    },
  ],
  closing: {
    heading: "Turn happy customers into booked calls",
    body: "Activate Reputation Management and start capturing reviews automatically — most teams see new 5-star reviews within 48 hours.",
  },
};
